import { render, staticRenderFns } from "./WYSIWIG.vue?vue&type=template&id=3c0730fc&scoped=true&"
import script from "./WYSIWIG.vue?vue&type=script&lang=js&"
export * from "./WYSIWIG.vue?vue&type=script&lang=js&"
import style0 from "./WYSIWIG.vue?vue&type=style&index=0&id=3c0730fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0730fc",
  null
  
)

export default component.exports